import { render } from "./HeroiconsOutlineUpload.vue?vue&type=template&id=f7246788"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUpload.vue"]])

export default __exports__